import { Link } from '@twistopayments/design-system/components/atoms/link'
import { hiddenDown } from '@twistopayments/design-system/styles'

import type { NavigationSignInButtonComponent } from '@twisto/api-cms'

import * as styles from './authentication.styles'

type Props = {
  source?: 'main' | 'modal'
  inverted?: boolean
}
export const SignInButton = ({
  text,
  source,
  inverted,
  url,
}: NavigationSignInButtonComponent & Props) => (
  <Link
    css={[
      styles.authButton,
      source !== 'modal' && hiddenDown('sm'),
      inverted ? styles.loginButton.dark : styles.loginButton.light,
    ]}
    hover="primary"
    to={url}
  >
    {text}
  </Link>
)
